__turbopack_context__.v({
  "root": "Reviews-module__2AC24q__root",
});
